import { UserFormData } from '@/entities/User/User'
import { formatDate } from '@/helpers/date'
import { getEnumKeyByEnumValue, isEnumValue } from '@/helpers/enum'
import { CompanyMedicType, DateFormat, GenderType, IdentificationType, WorkdayType } from '@/types'

import {
    BasicPerson,
    EditPersonRequest,
    Person,
    PersonResource,
} from './Person'

export const transformToBasicPerson = (
    firstname: string,
    lastname: string,
    affix = '',
): BasicPerson => ({
    firstname,
    affix,
    lastname,
})

const transformStringToWorkday = (value: string): WorkdayType | undefined => {
    const workday = getEnumKeyByEnumValue(WorkdayType, value)

    if (! workday) {
        console.error(`[transformStringToWorkday]: Unknown enum found named "${value}".`)

        return undefined
    }

    return WorkdayType[workday]
}

export const transformToGenderType = (value: unknown): GenderType => (
    isEnumValue(GenderType, value) ? value : GenderType.unknown
)

export const transformToIdentificationType = (value: unknown): IdentificationType => (
    isEnumValue(IdentificationType, value) ? value : IdentificationType.unknown
)

export const transformToPerson = (resource: PersonResource): Person => ({
    id: resource.id,
    firstname: resource.attributes.firstname,
    affix: resource.attributes.affix || undefined,
    lastname: resource.attributes.lastname,
    gender: transformToGenderType(resource.attributes.gender),
    birthday: resource.attributes.birthday ? new Date(resource.attributes.birthday) : undefined,
    hasSundayAllowance: resource.attributes.hasSundayAllowance,
    identificationExpirationDate: new Date(resource.attributes.identificationExpirationDate),
    identificationType: transformToIdentificationType(resource.attributes.identificationType),
    companyMedic: resource.attributes.isCompanyMedic || CompanyMedicType.unknown,
    nationality: resource.attributes.nationality,
    workdays: resource.attributes.workDays
        .map(transformStringToWorkday)
        .filter(workday => workday !== undefined),
})

export const transformFormDataToEditPersonRequest = (formData: UserFormData, personId: string): EditPersonRequest => ({
    type: 'people',
    id: personId,
    attributes: {
        firstname: formData.firstname,
        lastname: formData.lastname,
        affix: formData.affix,
        birthday: formatDate(formData.birthday, DateFormat.apiDate),
    },
})
